import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { computed } from 'mobx';
import {
  makeStyles,
  withStyles,
  MuiThemeProvider,
} from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Preview from '../../../components/Media/Preview';
import BaseTable from '../../../components/Media/BaseTable';
import adaTheme from '../../../theme';

//import { adaTheme } from '../../Editor';
import withStores from '../../../stores/withStores';
import CreationForm from '../../../components/Media/CreationForm';
import useI18n from '../../../i18n/useI18n';

const styles = theme => ({
  root: {
    position: 'relative',
  },
  fade: {
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0, 0.3)',
    },
    filter: 'blur(8px)',
  },
  form: {
    position: 'absolute',
    top: '50%',
    left: 0,
    zIndex: 1,
    width: '100%',
    transform: 'translate(0, -50%)',
    display: 'flex',
    justifyContent: 'space-around',
  },
  progress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 150,
  },
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '80%',
    height: '80%',
    background: theme.palette.common.white,
    overflow: 'auto',
    transform: 'translate(-50%, -50%)',
  },
});

const useFormButtonStyles = makeStyles(theme => ({
  root: {
    // margin: theme.spacing(2, 0),
  },
}));

const FormButton = props => {
  const classes = useFormButtonStyles();
  return <Button fullWidth variant="contained" classes={classes} {...props} />;
};

@withStyles(styles)
@withStores('mediaStore', 'appStore', 'pagesStore')
@observer
class MediaBlock extends React.Component {
  state = {
    showCreation: false,
    showModal: false,
  };

  static getDerivedStateFromProps(props) {
    if (props.isInteractive === false) {
      return {
        showModal: false,
        showCreation: false,
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    props.mediaStore.loadMediaItem(this.entity.data.uuid);
  }

  get block() {
    return this.props.block;
  }

  get entityKey() {
    return this.block.getEntityAt(0);
  }

  get entity() {
    return this.props.contentState.getEntity(this.entityKey);
  }

  @computed
  get mediaItem() {
    return this.props.mediaStore.getItem(this.entity.data.uuid);
  }

  handleCreate = response => {
    this.props.pagesStore.currentPage.updateEntityData(
      this.block.getKey(),
      this.entityKey,
      { uuid: response.data.uuid },
    );
  };
  handleSelectItem = item => {
    this.props.pagesStore.currentPage.updateEntityData(
      this.block.getKey(),
      this.entityKey,
      { uuid: item.uuid },
    );
    this.handleCloseModal();
  };

  handleOpenModal = () => {
    this.setState({
      showModal: true,
      showCreation: false,
    });
    this.props.onPreventClickAway(true);
  };

  handleOpenCreation = () => {
    this.setState({
      showModal: false,
      showCreation: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      showCreation: false,
    });
    this.props.onPreventClickAway(false);
  };

  get form() {
    const { classes, i18n, isInteractive } = this.props;
    const { showCreation, showModal } = this.state;
    return (
      <MuiThemeProvider theme={adaTheme}>
        <React.Fragment>
          <Box
            minHeight={120}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            {!showCreation && !showModal && isInteractive && (
              <React.Fragment>
                <FormButton onClick={this.handleOpenModal}>
                  {i18n.t('plugins.media.selectExisting')}
                </FormButton>
                <FormButton onClick={this.handleOpenCreation}>
                  {i18n.t('plugins.media.createNew')}
                </FormButton>
              </React.Fragment>
            )}
            {showCreation && (
              <CreationForm
                onChange={this.handleCreate}
                display="flex"
                flexDirection="column"
              />
            )}
          </Box>
          <Modal
            open={showModal}
            onClose={this.handleCloseModal}
            disableEnforceFocus={false}
            disableRestoreFocus={false}
          >
            <div className={classes.modalContent}>
              <BaseTable onSelectItem={this.handleSelectItem} />
            </div>
          </Modal>
        </React.Fragment>
      </MuiThemeProvider>
    );
  }

  render() {
    const { classes, appStore, isInteractive } = this.props;
    if (appStore.editMode && !this.entity.data.uuid) {
      return (
        <Box
          pt={2}
          pb={2}
          mt={10}
          bgcolor="sketch.grey3"
          width="100%"
          display="flex"
          justifyContent="space-around"
        >
          {this.form}
        </Box>
      );
    }
    if (!appStore.editMode && !this.entity.data.uuid) return null;
    if (!this.mediaItem) {
      return (
        <div className={classes.progress}>
          <CircularProgress
            variant="indeterminate"
            disableShrink
            size={24}
            thickness={4}
          />
        </div>
      );
    }
    return (
      <div className={cx(classes.root)}>
        {appStore.editMode && <div className={classes.form}>{this.form}</div>}
        <Box className={cx({ [classes.fade]: isInteractive })}>
          <Preview
            item={this.mediaItem}
            noMinifcation
            noInteraction={appStore.editMode}
          />
        </Box>
      </div>
    );
  }
}

const MediaBlockWithI18n = props => {
  const i18n = useI18n();
  return <MediaBlock {...props} i18n={i18n} />;
};

export default MediaBlockWithI18n;
